import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DefaultComponent } from './components/default/default.component';
import { SearchComponent } from './components/search/search.component';
import {RssFeedComponent} from './components/rss-feed/rss-feed.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SignupComponent } from './components/signup/signup.component';
import { AddSourceComponent} from './components/datasource/addsource.component'
import { SourcesComponent} from './components/datasource/sources.component'
import {AppComponent} from './app.component';

const routes: Routes = [
 // { path: '', component: AppComponent },
 { path: '', component: DefaultComponent },
  { path: 'login', component: DefaultComponent },
  { path: 'search', component: SearchComponent },
  { path: 'rss-feed', component: RssFeedComponent },
  { path: 'signup', component: SignupComponent },
  {path:'addsource',component:AddSourceComponent},
  {path:'sources',component:SourcesComponent},
  {path:'claims/:id',component:SearchComponent},
  { path: '**', component: PageNotFoundComponent },
  
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
